// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_shell_shell_module_ts":"c2aebc7b8bb63c1d","node_modules_apexcharts_dist_apexcharts_common_js":"c7f962a259861ebb","src_app_company-management_company-management_module_ts":"f25fc2af3d687766"}[chunkId] + ".js";
};